import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const LoadingFallback = () => (
  <div style={{
    height: '100vh', 
    display: 'flex', 
    flexDirection: 'column',
    justifyContent: 'center', 
    alignItems: 'center', 
    background: '#ffffff',
    color: '#1a0537',
    fontFamily: 'sans-serif',
    padding: '20px',
    textAlign: 'center'
  }}>
    <div style={{
      width: '40px', 
      height: '40px', 
      border: '4px solid rgba(0,0,0,0.1)', 
      borderLeftColor: '#ec4899', 
      borderRadius: '50%', 
      animation: 'spin 1s linear infinite'
    }}></div>
    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
  </div>
);

root.render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>
);